/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const CancelIncidentRecord = zod.object({
  "id": zod.string().uuid(),
  "cancellationReason": zod.string()
});

export type CancelIncidentRecord = zod.input<typeof CancelIncidentRecord>;
export type CancelIncidentRecordOutput = zod.output<typeof CancelIncidentRecord>;
